import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { nebankaOcpRoute } from '../NebankaOcpParentPage/route';

export const nebankaOcpAccountCanceledOrdersRoute = createRoute({
	path: '/expired-orders',
	getParentRoute: () => nebankaOcpRoute,
	component: lazyRouteComponent(
		() => import('./NebankaOcpAccountCanceledOrdersPage'),
		'NebankaOcpAccountCanceledOrdersPage',
	),
});
